import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

import { Icon } from '../Icon';

import { Wrapper } from './PageTitle.styles';

type Props = {
  title?: string | React.ReactNode;
  children?: React.ReactNode;
  showBackButton?: boolean;
  icon?: React.ReactNode;
  onBack?: () => void;
};

export const PageTitle: React.FC<Props> = ({
  title,
  children,
  icon,
  showBackButton = false,
  onBack
}) => {
  const navigate = useNavigate();
  return (
    <Wrapper $showTitleStyles={typeof title === 'string'}>
      <div style={{ width: '100%' }}>
        {showBackButton && (
          <Button
            type="text"
            data-testid="back-button"
            onClick={() => (onBack ? onBack() : navigate(-1))}
            icon={<Icon i="ArrowLeft" />}
          />
        )}
        {title}
        {icon}
      </div>
      {children}
    </Wrapper>
  );
};
